import UndoCommand from "./UndoCommand";

export default class UndoCommandParameterized<T> extends UndoCommand {
    undoAction: (data: T) => void;
    data: T;
    constructor(undoAction: (data: T) => void, data: T) {
        super()
        this.undoAction = undoAction
        this.data = data
    }
    doUndoAction(): void {
        this.undoAction(this.data)
    }

}